/** Single source for merchant-facing app name and support contact. */
export const APP_DISPLAY_NAME = "AgeShield";

/** Id in https://orbitsdev.com/orbits-partner-apps.json — hidden from this app's recommendations. */
export const PARTNER_APP_ID = "ageshield";

export const SUPPORT_EMAIL = "support@orbitsdev.com";

/** Merchant WhatsApp support (display + wa.me link). */
export const WHATSAPP_SUPPORT_NUMBER = "+91 8320872214";

/** Opens the default mail client for merchant support (works in embedded admin). */
export function openSupportEmail() {
  const url = `mailto:${SUPPORT_EMAIL}`;
  try {
    if (window.top && window.top !== window) {
      window.top.location.href = url;
    } else {
      window.location.href = url;
    }
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}

/** Digits-only E.164 for wa.me (no leading +). */
export function whatsAppSupportDigits() {
  return String(WHATSAPP_SUPPORT_NUMBER || "").replace(/\D/g, "");
}

/** WhatsApp chat URL for merchant support. */
export function getWhatsAppSupportUrl(prefillMessage = "") {
  const digits = whatsAppSupportDigits();
  if (!digits) return "";
  const base = `https://wa.me/${digits}`;
  const msg = String(prefillMessage || "").trim();
  return msg ? `${base}?text=${encodeURIComponent(msg)}` : base;
}
